import ExerciseBadge, {
  ExerciseType,
} from "@/components/v3/exercises/ExerciseBadge";
import ActionBar from "@/components/v3/exercises/ActionBar";
import ActionBarGrammarMobile from "@/components/exercises/grammar/Mobile/ActionBarGrammarMobile";

type Props = {
  type?: ExerciseType;
  title: string;
  timer?: number;
  onClose?: () => void;
  isGrammar?: boolean;
  isCorrection?: boolean;
  isTimerVisible?: boolean;
};

const LayoutHeaderMobile = ({
  type = ExerciseType.LISTENING,
  title,
  timer,
  onClose,
  isGrammar,
  isTimerVisible,
}: Props) => {
  return (
    <div className="flex flex-col px-2 pt-4 gap-2">
      <div className="flex sm:justify-end sm:mr-7">
        {isGrammar ? (
          <ActionBarGrammarMobile
            type={type}
            timer={timer}
            onClose={onClose}
            isTimerVisible={isTimerVisible}
          />
        ) : (
          <ActionBar type={type} onClose={onClose} />
        )}
      </div>

      <div className="flex flex-col items-start gap-2 ">
        <ExerciseBadge type={type as ExerciseType} />

        <p className="text-xl font-semibold text-white">{title}</p>
      </div>
    </div>
  );
};
export default LayoutHeaderMobile;
